import environment from "setup/environment";

export const makeWidgetEmbedCode = (
  venueIds: number[]
): string => `<script type="text/javascript">
var scriptTag=document.createElement("script");
scriptTag.onload=function(){window.TICKETING_PLATFORM_WIDGET.injectApp("widget-container",${
  venueIds.length ? JSON.stringify(venueIds) : undefined
})};
scriptTag.defer="defer";
scriptTag.src="${environment.WIDGET_DOMAIN}/static/js/index.js";
document.head.appendChild(scriptTag);
</script>`;
